import { render, staticRenderFns } from "./AICCares.vue?vue&type=template&id=8fbf4e66&scoped=true&"
import script from "./AICCares.vue?vue&type=script&lang=js&"
export * from "./AICCares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbf4e66",
  null
  
)

export default component.exports